const actions = {
  SET_STATE: 'user/SET_STATE',
  LOGIN_BY_TOKEN: 'user/LOGIN_BY_TOKEN',
  LOAD_CURRENT_ACCOUNT: 'user/LOAD_CURRENT_ACCOUNT',
  LOGOUT: 'user/LOGOUT',
  UMK_LOGIN: 'user/UMK_LOGIN',
  UMK_REGISTER: 'user/UMK_REGISTER',
  UMK_CHANGEPW: 'user/UMK_CHANGEPW',
  SET_RESET_PW: 'user/SET_RESET_PW',
  BASIC_REGISTER: 'user/BASIC_REGISTER',
  BASIC_LOGIN: 'user/BASIC_LOGIN',
  SELECT_WORKSPACE: 'user/SELECT_WORKSPACE',
  SET_WORKSPACE_NAME: 'user/SET_WORKSPACE_NAME',
  SET_USER_NAME: 'user/SET_USER_NAME',
  SET_USER_AVATAR: 'user/SET_USER_AVATAR',
  SET_LEAKED_RECORD_COUNT: 'user/SET_LEAKED_RECORD_COUNT',
} as const

export type UserActionTypes = typeof actions

export default actions
